import {
  Accordion as AccordionBase,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/common/components/ui/accordion";
import { createRef, useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";

export interface AccordionProps {
  name?: string;
  head: JSX.Element | string;
  body: JSX.Element | string;
  className?: string;
  iconStyles?: string;
  triggerClassName?: string;
  triggerDisabled?: boolean;
  contentClassName?: string;
  bodyClassName?: string;
  onToggle?: (isOpen: boolean) => void;
  defaultOpen?: boolean;
}

const Accordion = ({
  name,
  head,
  body,
  className,
  iconStyles,
  triggerClassName,
  triggerDisabled,
  contentClassName,
  bodyClassName,
  onToggle,
  defaultOpen = false,
}: AccordionProps) => {
  const contentRef = createRef<HTMLDivElement>();
  const [value, setValue] = useState(defaultOpen ? "item-1" : "");

  const defaultOnToggle = (isOpen: boolean) => {
    if (!contentRef.current) return;
    if (isOpen) {
      (contentRef.current as HTMLDivElement).classList.remove("hidden");
      setTimeout(() => { if (contentRef.current) contentRef.current.classList.add("overflow-visible") }, 300);
    } else {
      setTimeout(() => { if (contentRef.current) contentRef.current.classList.add("hidden") }, 100);
      contentRef.current.classList.remove("overflow-visible");
    }
  };

  const handleOnToggle = (itemName: string) => {
    setValue(itemName);
    onToggle && onToggle(!!itemName);
  }

  useEffect(() => {
    defaultOnToggle(!!value);
  }, [value])

  return (
    <AccordionBase
      type="single"
      collapsible
      className={twMerge("w-full p-4 rounded-sm bg-white-100", className)}
      onValueChange={handleOnToggle}
      value={value}
    >
      <AccordionItem value="item-1" >
        <AccordionTrigger
          className={twMerge("py-4", triggerClassName)}
          disabled={triggerDisabled}
          iconStyles={iconStyles}
          data-testid={`accordion_${name}_trigger`}
        >
          {head}
        </AccordionTrigger>
        <AccordionContent ref={contentRef} containerClassName={contentClassName} className={bodyClassName}>
          {body}
        </AccordionContent>
      </AccordionItem>
    </AccordionBase>
  );
};

export default Accordion;
